module.exports = __webpack_public_path__ + "media/images/sec1-750a1275309664ee444ea64934bb4bdf.svg";